import { useContext } from "react";
import { VacanciesContext } from "./VacanciesContext";

export const useVacancies = () => {
    const context = useContext(VacanciesContext);
    if (!context) {
        throw new Error("useVacancies must be used within a VacanciesProvider");
    }
    return context;
};